import { CustomerIntakeFormConfig } from '../types/CustomerIntake.type';
import { ServiceType } from '../types/ServiceAccordion.type';
import { apiGet } from './apiClient';

type ApiEnvelope<T> = {
  status: number;
  message: string;
  data: T;
};

type PackageFormConfigurationPayload = {
  packageId: number;
  formConfiguration: (CustomerIntakeFormConfig & { schemaVersion: 1 }) | null;
};

const parsePackageId = (id: string | number) => {
  const packageId = Number(id);
  if (!Number.isInteger(packageId) || packageId <= 0) {
    throw new Error('Invalid package ID.');
  }
  return packageId;
};

export const listServiceTree = async () => {
  const response = await apiGet<ApiEnvelope<ServiceType[]>>('/service/list');
  return response.data;
};

export const getSubSubtypeFormConfiguration = async (id: string | number) => {
  const packageId = parsePackageId(id);
  const response = await apiGet<ApiEnvelope<PackageFormConfigurationPayload>>(
    `/service/sub-subtype/${packageId}/form-configuration`,
  );
  return response.data.formConfiguration;
};
